<template>
    <!-- @TODO refactor me to use CustomSelects -->
    <div v-click-outside="close" class="phoneme-select">
        <div
            :class="{ 'is-opened': opened, 'is-disabled': disabled }"
            class="select"
            style="width: 240px; padding-right: 0"
            @click="toggle"
        >
            <div class="select__field">
                <button class="select__button">
                    <div v-if="value" class="select__value">{{ value }}</div>
                    <div v-else class="select__placeholder">
                        {{ $t('editor.ssml.phoneme.placeholder') }}
                    </div>
                </button>
            </div>
            <transition name="fade">
                <div
                    v-show="opened"
                    :class="{ 'is-visible': opened }"
                    class="select__dropdown"
                    style="top: calc(100% + 10px)"
                >
                    <ul class="select__list">
                        <slot name="first-item" />
                        <li
                            v-for="option in options"
                            :key="option.value"
                            class="select__option phoneme-select__option"
                            @click="select(option.value)"
                        >
                            <PlayButton @click.prevent.stop="getSample(option.id)" />
                            {{ option.value }}
                        </li>
                        <slot name="last-item" />
                    </ul>
                </div>
            </transition>
        </div>
        <button v-if="value" type="button" class="phoneme-select__icon" @click.stop="clear">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="10" height="10">
                <path
                    d="M505.943 6.058c-8.077-8.077-21.172-8.077-29.249 0L6.058 476.693c-8.077 8.077-8.077 21.172 0 29.249A20.612 20.612 0 0020.683 512a20.614 20.614 0 0014.625-6.059L505.943 35.306c8.076-8.076 8.076-21.171 0-29.248z"
                />
                <path
                    d="M505.942 476.694L35.306 6.059c-8.076-8.077-21.172-8.077-29.248 0-8.077 8.076-8.077 21.171 0 29.248l470.636 470.636a20.616 20.616 0 0014.625 6.058 20.615 20.615 0 0014.624-6.057c8.075-8.078 8.075-21.173-.001-29.25z"
                />
            </svg>
        </button>
    </div>
</template>

<script>
import { PlayButton } from '@speechki-frontend/shared/ui/Player';
import { clickOutside } from '@speechki-frontend/shared/helpers/directives/clickOutside';

export default {
    name: 'PhonemeSelect',
    components: {
        PlayButton
    },
    directives: {
        clickOutside
    },
    props: {
        options: {
            type: Array,
            default: () => []
        },
        value: {},
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            opened: false
        };
    },
    methods: {
        toggle() {
            this.opened = !this.opened;
        },
        select(item) {
            this.$emit('selected', { phoneme: item, save: false });
        },
        trim(text) {
            if (text.length < this.textThreshold) return text;
            return text.slice(0, this.textThreshold) + '...';
        },
        close() {
            this.opened = false;
        },
        clear() {
            this.$emit('cleared');
        },
        getSample(id) {
            this.$emit('playSample', id);
        }
    }
};
</script>
